<!-- @format -->
<script lang="ts">
    import { getStoresContext } from "~/stores";
    import type { StoresKey } from "~/stores";
    import type { ManageAPI } from "~/manage-api/types";
    import { parseOpeningHoursItem, toRangeOfDaysOfTheWeek } from "~/util/date-n-time";

    export let request_store_key: StoresKey;
    export let as_link = false;
    const { opening_hours, locale , T, reverse_router} = getStoresContext(request_store_key);
    $: t = $T;

    let content:any = []
    let ranges: string[] = [];
    let status: string = "";
    let dailyOH: ManageAPI.OpeningHoursItem[];

  $: {
    if ($opening_hours && t) {
      dailyOH = $opening_hours.shoppingCenterOpeningHours
      for(let schedule of dailyOH) {
        let days = toRangeOfDaysOfTheWeek(schedule.days, $locale)
        if ("days" in schedule) {
          status = schedule.openingStatus;
          // Change time to 12 hour format for English locale only
          if(locale.value == 'en-US') {
            ranges = parseOpeningHoursItem($locale, schedule, true);
            ranges = ranges.map(h=>{return h.toUpperCase(); });
          } else {
            ranges = parseOpeningHoursItem($locale, schedule);
          }
          ranges = ranges.map(h=>{return h.replace(' - ', '—'); });
        }
        let itemOH = {
          days,
          hours: ranges,
          isOpen: status == 'OPEN',
          openingStatus: status,
          statusText: t(`opening-status-${status.toLowerCase}`)
        }
        content.push(itemOH)
      }
    } 
  }

  $: openinghours_path = $reverse_router.routePurpose("opening hours");

  function deriveMonday(date:Date, day: 0|1) {
    const to_date = new Date(date.getFullYear(), date.getMonth(), today.getDate());
    /* Either current weeks monday or next monday */
    const sub = [1, 8][day] - to_date.getDay();
    to_date.setDate(to_date.getDate() + sub);
    return to_date;
  }

  const today = new Date();
  const monday = deriveMonday(today, 0);
  const monday_next = deriveMonday(today, 1);

  $: week_with_exceptions = $opening_hours
    ? $opening_hours.exceptionalOpeningHours.some((x) => {
        const exception_date = new Date(x.date);
        return monday <= exception_date && exception_date < monday_next;
      })
    : false;
    function navigate() {
      window.location.href = `${openinghours_path}`;
    }
</script>

<div class="hours">
  {#if $opening_hours}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    {#each content as row}
      <div class="day-range" class:as_link on:click={navigate}>
        {@html row.days}
        {#if row.isOpen}
          {#each row.hours as hours}
            <span class="hours-range">{ hours }</span>        
          {/each}
        {:else}
          {row.statusText}
        {/if}
      </div>
    {/each}
    {#if week_with_exceptions}
      <a href={openinghours_path}>{t`opening-hours-exceptions`}</a>
    {/if}  
  {/if}
</div>

<style lang="scss">
  a {
    text-decoration: underline;
    text-underline-offset: 0.05em;
  }
  .as_link:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .hours {
    font-size: 18px;
    color: #4e545b;
  }

  .hours-range {
    white-space: nowrap;
  }
</style>